import React from "react";
import { Layout } from 'antd';
//import { AppstoreAddOutlined,CoffeeOutlined,DollarOutlined} from '@ant-design/icons';



const NavFooter = () => {
    return (
        <Layout.Footer className={'main-footer'}>
            <div>
                QUANTDATA TECHNOLOGE (SHANGHAI) CO.,LTD ©2021
            </div>
            <div>
                <a href="https://beian.miit.gov.cn" target="_blank" rel="noreferrer">沪ICP备18039826号</a>
            </div>
        </Layout.Footer>
    );
}

export default NavFooter